import {useEffect, useId, useRef, useState} from 'react'

import {BREAKPOINT} from '../../webgl/_rawConfig'
import type {BrandedDividerParams} from '../WebGLContext/WebGLContext'
import {useWebGLContext} from '../WebGLContext/WebGLContext'

interface WebGLBrandedDividerProps {
  className?: string
  params: BrandedDividerParams
  /**
   * Opt into compensating the WebGL canvas transform for the WebGLPage
   * wrapper's viewport offset. See `BrandedDividerRegistration.offsetByWrapperTop`.
   */
  offsetByWrapperTop?: boolean
}

export function WebGLBrandedDivider({className, params, offsetByWrapperTop}: WebGLBrandedDividerProps) {
  const {registerBrandedDivider, unregisterBrandedDivider} = useWebGLContext()
  const ref = useRef<HTMLDivElement>(null)
  const id = useId()
  const [aspectRatio, setAspectRatio] = useState('1600 / 157')

  useEffect(() => {
    if (ref.current) {
      registerBrandedDivider({id, element: ref.current, params, offsetByWrapperTop})
    }

    const resize = () => {
      if (window.innerWidth <= BREAKPOINT.MOBILE) {
        setAspectRatio(`390 / 115`)
      } else if (window.innerWidth <= BREAKPOINT.TABLET) {
        setAspectRatio(`800 / 131`)
      } else {
        setAspectRatio(`1600 / 157`)
      }
    }

    resize()
    window.addEventListener('resize', resize)

    return () => {
      unregisterBrandedDivider(id)
      window.removeEventListener('resize', resize)
    }
  }, [])

  return (
    <div
      ref={ref}
      className={className}
      style={{
        width: '100%',
        maxWidth: '1600px',
        aspectRatio,
      }}
    />
  )
}
